// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gkWB","right":"styles_right__1c9ya"};